var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEquipmentLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_equipment_link",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_link",
    transform: "translate(-2.685 10.002) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M9.614,17.21l-.032,0a.445.445,0,0,0-.258.121L7.586,19.071a1.959,1.959,0,0,1-2.77-2.77l1.845-1.845a1.947,1.947,0,0,1,.307-.25,1.977,1.977,0,0,1,.4-.2,1.883,1.883,0,0,1,.4-.1,1.907,1.907,0,0,1,.274-.019c.038,0,.075,0,.124.005a1.953,1.953,0,0,1,1.259.565,1.928,1.928,0,0,1,.46.734.423.423,0,0,0,.519.272l.008,0s.005,0,.005,0a.42.42,0,0,0,.282-.514,2.437,2.437,0,0,0-.662-1.1,2.831,2.831,0,0,0-1.549-.788c-.051-.008-.1-.016-.153-.022a2.775,2.775,0,0,0-.3-.016c-.07,0-.14,0-.207.008a2.712,2.712,0,0,0-.436.067c-.03.005-.056.013-.086.022a2.8,2.8,0,0,0-.524.2,2.762,2.762,0,0,0-.745.535L4.2,15.688a2.837,2.837,0,0,0-.82,2,2.828,2.828,0,0,0,4.824,2l1.756-1.756A.426.426,0,0,0,9.614,17.21Z",
    transform: "translate(0 -5.953)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M19.969,4.2a2.834,2.834,0,0,0-4,0L14.257,5.914a.432.432,0,0,0,.272.737.437.437,0,0,0,.342-.124l1.716-1.71a1.959,1.959,0,0,1,2.77,2.77L17.511,9.431a1.947,1.947,0,0,1-.307.25,1.977,1.977,0,0,1-.4.2,1.883,1.883,0,0,1-.4.1,1.907,1.907,0,0,1-.274.019c-.038,0-.078,0-.124-.005a1.933,1.933,0,0,1-1.7-1.25.43.43,0,0,0-.514-.264.434.434,0,0,0-.3.551,2.456,2.456,0,0,0,.637,1.008h0l.005.005a2.831,2.831,0,0,0,1.7.809,2.775,2.775,0,0,0,.3.016q.1,0,.21-.008a3.075,3.075,0,0,0,.519-.086,2.8,2.8,0,0,0,.524-.2,2.762,2.762,0,0,0,.745-.535L19.974,8.2a2.831,2.831,0,0,0-.005-4Z",
    transform: "translate(-6.233)",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEquipmentLink);
export default __webpack_public_path__ + "static/media/ic_equipment_link.466fbb67c8511aa8e0c71fa9a01b548f.svg";
export { ForwardRef as ReactComponent };